// extracted by mini-css-extract-plugin
export default {"contentImageArea":"SmoPage_contentImageArea__4ik6N","contentImage":"SmoPage_contentImage__4R5fV"};